import { useEffect, useState } from 'react'
import BackToTopButton from '../../components/backToTopButton/BackToTopButton'
import AppFooter from '../../sections/footer/AppFooter'
import { userStateData } from '../../data/userStateData';
import { PAGE_URLS } from '../../constants/hrefLinks';

import './style.scss';
import { UserFollowerData, UserPost } from '../../types/posts';
import AppUserPost from '../../components/app_userPost/AppUserPost';
import { communityStateData } from '../../data/communityStateData';
import { postConnector } from '../../server/connector/postConnector';
import { userConnector } from '../../server/connector/userConnector';
import { UserData } from '../../server/types';
import { getProfileHeroPicPath, getProfilePicPath } from '../../constants/instructorConstants';
import AppComment from '../../components/app_comment/AppComment';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { setUserPosts } from '../../redux/reducers/postSlice';

function AppProfileUser() {

	const commentPost = useAppSelector((state) => state.post.commentPost)
	const dispatch = useAppDispatch()

	const [urlUserId, setUrlUserId] = useState<string>('')
	const [heroImgSrc, setHeroImgSrc] = useState<string | undefined>(undefined) // useState<string>('')
	const [profileImgSrc, setProfileImgSrc] = useState<string | undefined>(undefined)
	
	const [usersName, setUsersName] = useState<string>('')
	const [bioExpanded, setBioExpanded] = useState<boolean>(false)
	const [bioText, setBioText] = useState<string>('')
	const [userIsVerified, setUserIsVerified] = useState<boolean>(true)

	const [showingReels, setShowingReels] = useState<boolean>(true)

	// const [userPosts, setUserPosts] = useState<UserPost[]>([])
	const userPosts = useAppSelector(state => state.post.userPosts)

	const [userFollowers, setUserFollowers] = useState<UserFollowerData[]>([])
	const [followConnecting, setFollowConnecting] = useState<boolean>(false)
	const [isFollowing, setIsFollowing] = useState<boolean>(false)

	const [isUsersProfile, setIsUsersProfile] = useState<boolean>(false)

	useEffect(() => {
		// Assumes the log in check is done in the root App component before any page components are added to the dom
		if (userStateData.loggedIn === false) {
			window.location.replace(`${PAGE_URLS.APP_ENTRY}`)
		} else {
			// Load profile data
			// setBioText('Thisis the users Bio section where they can write a little about who they are. The text will appears cut off until it is expanded by clicking the show more button')
			getProfileData()
		}
	}, [])

	const getProfileData = () => {
		const querySting: string = window.location.search;
		const urlParams: URLSearchParams = new URLSearchParams(querySting)
		const userId: string | null = urlParams.get('id')
		setUrlUserId(userId ? userId : '')

		if (userId) {
			if (userId == userStateData.getId()) {
				setIsUsersProfile(true)
				setUsersName(userStateData.getUsersName())
				const bioStr: string = userStateData.getAboutText() || ''
				setBioText(bioStr)
				setUserIsVerified(true)

				setHeroImgSrc(userStateData.getUserHeroUrl())
				setProfileImgSrc(userStateData.getUserIconUrl())

				communityStateData.userPosts = []
				postConnector.getUserPostsRequest(userStateData.getId()).then((successResponse) => {
					// setUserPosts(communityStateData.userPosts)
					dispatch(setUserPosts(communityStateData.userPosts))
				})
			} else {
				setIsUsersProfile(false)

				userConnector.getUserDataRequest(userId).then((userData: UserData | undefined) => {
					// console.log(userData)
					if (userData) {
						// console.log(userData)
						setUsersName(userData.name)
						if (userData.hero_pic) {
							setHeroImgSrc(getProfileHeroPicPath(userData.hero_pic))
						}
						if (userData.profile_pics) {
							setProfileImgSrc(getProfilePicPath(userData.profile_pics, 0))
						}
						if (userData.about_text) {
							setBioText(userData.about_text)
						}
					} else {
						setUsersName('User')
					}

					userConnector.getUserFollowDataRequest(userStateData.getId()).then((followerData: UserFollowerData[]) => {
						// if (followerData.includes((follower: UserFollowerData) => follower.user_id === userStateData.getId()))
						let isFollowingThisUser: boolean = false
						followerData.forEach((follower: UserFollowerData) => {
							if (follower.follow_id == userId) {
								isFollowingThisUser = true
							}
						})
						setIsFollowing(isFollowingThisUser)
						// setUserFollowers(followerData)

						userConnector.getFollowUsersDataRequest(userId).then((followerData: UserFollowerData[]) => {
							setUserFollowers(followerData)
						})
					})
				})

				communityStateData.userPosts = []
				postConnector.getUserPostsRequest(userId).then((successResponse) => {
					// setUserPosts(communityStateData.userPosts)
					dispatch(setUserPosts(communityStateData.userPosts))
				})
			}
		}
	}

	const followButtonClickHandler = () => {
		if (isFollowing) {
			unfollowUser()
		} else {
			followUser()
		}
	}

	const followUser = () => {
		setFollowConnecting(true)
		if (urlUserId) {
			userConnector.followUserRequest(urlUserId, userStateData.getId()).then((successResponse) => {
				setIsFollowing(true)
				setFollowConnecting(false)
			})
		}
	}

	const unfollowUser = () => {
		setFollowConnecting(true)
		if (urlUserId) {
			userConnector.unfollowUserRequest(urlUserId, userStateData.getId()).then((successResponse) => {
				setIsFollowing(false)
				setFollowConnecting(false)
			})
		}
	}

	return (
		<>
			<div className='section-wrap section-seperator lcp-shift-min-height extra-footer-space app-profile-user-full-section'>
				<div className='app-profile-user-top-section-wrap'>
					<div className='app-profile-user-top-section'>
						{/* <div className='app-profile-user-top-section-cover-image' /> */}
						<div className='app-profile-user-top-section-cover-image'>
							{heroImgSrc !== undefined &&
								<img
									className='app-profile-user-top-section-cover-image-img'
									src={heroImgSrc}
									alt='Hero Img'
								/>
							}
						</div>
						<div
							className='app-profile-user-img-wrap'
							// href={PAGE_URLS.DASHBOARD_CUSTOMER}
						>
							{profileImgSrc !== undefined &&
								<img 
									className='app-profile-user-img'
									src={profileImgSrc}
									alt='Profile'
								/>
							}
						</div>
					</div>
				</div>
				<div className='app-profile-user-bio-section-wrap'>
					<div className='app-profile-user-top-name-wrap'>
						<div className='app-profile-user-top-name'>{usersName}</div>
						{userIsVerified && 
							<img
								className='app-profile-user-verify-tick'
								src='/imgs/icons/profile/icon-profile-verified-tick.svg'
								alt='Verified tick'
							/>
						}
						{/* <div className='app-profile-user-top-name-button'>
							<div className='app-profile-user-top-name-button-label'>Friend</div>
						</div> */}
						{isUsersProfile ? 
							<button 
								className='app-profile-user-bio-section-button'
								onClick={() => {
									window.location.replace(`${PAGE_URLS.APP_SETTINGS}`)
								}}
							>
								<div className='app-profile-user-bio-section-button-label'>Edit Profile</div>
							</button>
							:
							<button 
								className='app-profile-user-bio-section-button'
								disabled={followConnecting}
								onClick={() => {
									followButtonClickHandler()
								}}
							>
								<div className='app-profile-user-bio-section-button-label'>{followConnecting ? '...' : isFollowing ? 'Unfollow' : 'Follow'}</div>
							</button>
						}
					</div>
					<div className='app-profile-user-friend-wrap'>
						{/* <div className='app-profile-user-friend-icon' />
						<div className='app-profile-user-friend-icon' />
						<div className='app-profile-user-friend-icon' /> */}
						<div className='app-profile-user-friend-label'>{userFollowers.length} Follower{userFollowers.length == 1 ? '' : 's'}</div>
						<div className='app-profile-user-public-wrap'>
							<img
								className='app-profile-user-public-img'
								alt='Public icon'
								src='/imgs/icons/profile/icon-profile-public.svg'
							/>
							<div className='app-profile-user-public-label'>Public</div>
						</div>
					</div>
					<div 
						// className={`app-profile-user-bio-wrap ${bioExpanded ? 'app-profile-user-bio-expanded' : ''}`}
						className='app-profile-user-bio-text'
					>
						{bioText.length > 1 ? 
							<>
								{bioExpanded ? bioText : `${bioText.substring(0, 20)} ... `}
								{bioExpanded === false && 
									<div 
										className='app-profile-user-bio-show-more'
										onClick={() => {
											setBioExpanded(true)
										}}
									>see more</div>
								}
							</> :
							<>No Bio Provided</>
						}
					</div>
					<div className='app-profile-user-switch-wrap'>
						<div 
							className={`app-profile-user-switch-button ${showingReels === true ? 'app-profile-user-switch-button-selected' : ''}`}
							onClick={() => {
								setShowingReels(true)
							}}
						>
							<img 
								className='app-profile-user-switch-img'
								src={`/imgs/icons/profile/icon-profile-icon-reel-${showingReels === true ? 'active' : 'inactive'}.svg`}
								alt='reel switch'
							/>
						</div>
						{/* <div className='app-profile-user-switch-button'> */}
						<div 
							className={`app-profile-user-switch-button ${showingReels === false ? 'app-profile-user-switch-button-selected' : ''}`}
							onClick={() => {
								setShowingReels(false)
							}}
						>
							<img 
								className='app-profile-user-switch-img'
								// src='/imgs/icons/profile/icon-profile-icon-community-active.svg'
								src={`/imgs/icons/profile/icon-profile-icon-community-${showingReels === false ? 'active' : 'inactive'}.svg`}
								alt='community switch'
							/>
						</div>
					</div>
				</div>
				<div className='app-profile-user-content-section-wrap'>
					{showingReels ? 
						<>
							{userPosts.length > 0 ?
								userPosts.map((postData: UserPost, index: number) => <AppUserPost data={postData} key={`post${index}`} />)
								:
								<div className='app-profile-user-content-section-empty-text'>
									<div className='app-profile-user-content-section-empty-text-title'>You haven't posted anything yet...</div>
									<div className='app-profile-user-content-section-empty-text-sub-text'>Get started by going to communities<br/>and tapping the post button!</div>
								</div>
							}
						</>
						:
						<div className='app-profile-user-content-section-empty-text'>
							{/* <div className='app-profile-user-content-section-empty-text-title'>You haven't posted anything yet...</div> */}
							<div className='app-profile-user-content-section-empty-text-title'>You haven't joined yet...</div>
							<div className='app-profile-user-content-section-empty-text-sub-text'>Get started by going to communities<br/>and joining a group!</div>
						</div>
					}
				</div>
			</div>
			<BackToTopButton />
			<AppFooter activeIndex={4} remainActive={urlUserId != userStateData.getId()} />
			{commentPost && <AppComment postData={commentPost} />}
		</>
	)
}

export default AppProfileUser
